import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import TherapyInsurer from "./TherapyInsurer"
import TherapyAge from "./TherapyAge"
import AddIcon from "@material-ui/icons/Add"
import TherapySlideOld from "./TherapySlideOld"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceTherapy extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  therapy_price_id: "",
                  selectedCompany: "",
                  selectedFranchise: "",
                  selectedCovarage: "",
                  therapy_price_disc: "",
                  therapy_price_urldesc: "",
                  therapy_price_desc: "",
                  therapy_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "therapy_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceTherapy: true,
                  optionCompany: [],
                  optionFranchise: [],
                  optionCovarage: [],
                  openDialog: false,
                  therapyInsurer: [],
                  therapyAges: [],
                  therapy_price_baseinsurer_percent: "",
                  therapy_price_age_price: "",
                  selectedTherapyInsurer: "",
                  selectedTherapyAge: "",
                  therapySlideOlds: [],
                  therapy_slideold_percent: "",
                  therapy_slideold_min: "",
                  therapy_slideold_max: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleSlidePriceOldMin = (event) => {
            this.setState({ therapy_slideold_min: event })
      }
      handleSlidePriceOldMax = (event) => {
            this.setState({ therapy_slideold_max: event })
      }

      handleChangeSlideOldPercent = (event) => {
            this.setState({ therapy_slideold_percent: event })
      }

      handleCovarage = (selectedCovarage) => {
            this.setState({ selectedCovarage: selectedCovarage }, () => {})
      }
      handleFranchise = (selectedFranchise) => {
            this.setState({ selectedFranchise: selectedFranchise }, () => {})
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceTherapy()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ therapy_price_deactive: "0" })
            } else {
                  this.setState({ therapy_price_deactive: "1" })
            }
      }

      handleTherapyInsurer = (selectedTherapyInsurer) => {
            this.setState({ selectedTherapyInsurer: selectedTherapyInsurer })
      }

      handleChangeTherapyInsurer = (event) => {
            this.setState({ therapy_price_baseinsurer_percent: event })
      }

      handleTherapyAge = (selectedTherapyAge) => {
            this.setState({ selectedTherapyAge: selectedTherapyAge })
      }

      handleChangeTherapyAge = (event) => {
            this.setState({ therapy_price_age_price: event })
      }

      handleSelectRows = (row2) => {
            this.getTherapySlideold(row2.therapy_price_id)
            this.gettherapyInsurer(row2.therapy_price_id)
            this.gettherapyAge(row2.therapy_price_id)
            this.setState(
                  {
                        therapy_price_id: row2.therapy_price_id,

                        selectedCompany: { value: row2.therapy_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedCovarage: { value: row2.therapy_price_coverage_id, label: row2.therapy_coverage_name },
                        selectedFranchise: { value: row2.therapy_price_franchise_id, label: row2.therapy_franchise_name },
                        therapy_price_urldesc: row2.therapy_price_urldesc,
                        therapy_price_desc: row2.therapy_price_desc,
                        therapy_price_disc: row2.therapy_price_disc,

                        therapy_price_deactive: row2.therapy_price_deactive,
                        company_logo_url: row2.company_logo_url,
                        newPriceTherapy: false,
                  },
                  () => {}
            )
      }

      newPriceTherapy = (event) => {
            this.setState({
                  therapy_price_id: "",
                  selectedCompany: "",
                  selectedFranchise: "",
                  selectedCovarage: "",
                  therapy_price_deactive: "0",
                  company_logo_url: "",
                  therapy_price_urldesc: "",
                  therapy_price_desc: "",
                  therapy_price_disc: "0",
                  newPriceTherapy: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceTherapy()
                                    self.getoptionCompany()
                                    self.getoptionFranchise()
                                    self.getoptionCovarage()
                                    self.getoptionTherapyInsurer()
                                    self.getoptionTherapyAge()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deletePriceTherapy = () => {
            const { therapy_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceTherapy()
                              self.newPriceTherapy()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_therapy_price")
            fd.append("therapy_price_id", therapy_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceTherapy() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceTherapy()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_price")

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getTherapySlideold(therapy_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            this.setState({ therapySlideOlds: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState(
                                          {
                                                therapySlideOlds: arr.data,
                                          },
                                          () => {}
                                    )
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_therapy_slideold")
                  fd.append("therapy_price_id", therapy_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      gettherapyInsurer(therapy_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ therapyInsurer: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ therapyInsurer: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_baseinsurer")
                  fd.append("therapy_price_id", therapy_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      gettherapyAge(therapy_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ therapyAge: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ therapyAge: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_age")
                  fd.append("therapy_price_id", therapy_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceTherapy()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "therapyins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionTherapyInsurer = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].therapy_baseinsurer_id, label: arr.data[k].therapy_baseinsurer_name })
                              }
                              self.setState({ optionTherapyInsurer: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_baseinsurer")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      getoptionTherapyAge = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].therapy_age_id, label: arr.data[k].therapy_age_name })
                              }
                              self.setState({ optionTherapyAge: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_age")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      getoptionCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].therapy_coverage_id, label: arr.data[k].therapy_coverage_name })
                              }
                              self.setState({ optionCovarage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }
      getoptionFranchise = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].therapy_franchise_id, label: arr.data[k].therapy_franchise_name })
                              }
                              self.setState({ optionFranchise: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_franchise")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      saveNewPriceTherapy = () => {
            const {
                  therapy_price_disc,
                  therapy_price_urldesc,
                  therapy_price_desc,
                  selectedCompany,
                  selectedFranchise,
                  selectedCovarage,
                  therapy_price_deactive,
            } = this.state
            if (selectedCompany !== "" && selectedCovarage !== "" && selectedFranchise !== "" && therapy_price_disc !== "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceTherapy()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_therapy_price")

                  fd.append("therapy_price_fieldcompany_id", selectedCompany.value)
                  fd.append("therapy_price_franchise_id", selectedFranchise.value)
                  fd.append("therapy_price_coverage_id", selectedCovarage.value)
                  fd.append("therapy_price_disc", therapy_price_disc)
                  fd.append("therapy_price_urldesc", therapy_price_urldesc)
                  fd.append("therapy_price_desc", therapy_price_desc)
                  fd.append("therapy_price_deactive", therapy_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceTherapyOld = () => {
            const { therapy_price_id, therapy_slideold_min, therapy_slideold_max, therapy_slideold_percent } = this.state
            if ((therapy_slideold_min != "" || therapy_slideold_max != "") && therapy_slideold_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ therapy_slideold_percent: "", therapy_slideold_min: "", therapy_slideold_max: "" })
                                    self.getTherapySlideold(therapy_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_therapy_slideold")
                  fd.append("therapy_slideold_therapy_price_id", therapy_price_id)
                  fd.append("therapy_slideold_percent", therapy_slideold_percent)
                  fd.append("therapy_slideold_min", therapy_slideold_min)
                  fd.append("therapy_slideold_max", therapy_slideold_max)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceTherapyInsurer = () => {
            const { therapy_price_id, selectedTherapyInsurer, therapy_price_baseinsurer_percent } = this.state
            if (selectedTherapyInsurer != "" && therapy_price_baseinsurer_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ therapy_price_baseinsurer_percent: "", selectedTherapyInsurer: "" })
                                    self.gettherapyInsurer(therapy_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_baseinsurer")
                  fd.append("therapy_price_baseinsurer_therapy_price_id", therapy_price_id)
                  fd.append("therapy_price_baseinsurer_percent", therapy_price_baseinsurer_percent)
                  fd.append("therapy_price_baseinsurer_therapy_baseinsurer_id", selectedTherapyInsurer.value)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceTherapyAge = () => {
            const { therapy_price_id, selectedTherapyAge, therapy_price_age_price } = this.state
            if (selectedTherapyAge != "" && therapy_price_age_price != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ therapy_price_age_price: "", selectedTherapyAge: "" })
                                    self.gettherapyAge(therapy_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_age")
                  fd.append("therapy_price_age_therapy_price_id", therapy_price_id)
                  fd.append("therapy_price_age_price", therapy_price_age_price)
                  fd.append("therapy_price_age_therapy_age_id", selectedTherapyAge.value)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceTherapy2 = () => {
            const {
                  therapy_price_id,
                  therapy_price_urldesc,
                  therapy_price_desc,
                  therapy_price_disc,
                  selectedCompany,
                  selectedFranchise,
                  selectedCovarage,
                  therapy_price_deactive,
            } = this.state
            if (selectedCompany != "" && therapy_price_disc != "" && selectedFranchise != "" && selectedCovarage != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceTherapy()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_therapy_price")
                  fd.append("therapy_price_id", therapy_price_id)

                  fd.append("therapy_price_fieldcompany_id", selectedCompany.value)
                  fd.append("therapy_price_franchise_id", selectedFranchise.value)
                  fd.append("therapy_price_coverage_id", selectedCovarage.value)
                  fd.append("therapy_price_urldesc", therapy_price_urldesc)
                  fd.append("therapy_price_desc", therapy_price_desc)
                  fd.append("therapy_price_disc", therapy_price_disc)
                  fd.append("therapy_price_deactive", therapy_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/therapy`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangeDisc = (event) => {
            this.setState({ therapy_price_disc: event })
      }
      handleChangUrlDesc = (event) => {
            this.setState({ therapy_price_urldesc: event.target.value })
      }
      handleChangeDesc = (event) => {
            this.setState({ therapy_price_desc: event.target.value })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceTherapy = () => {
            const { selectedCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (selectedCompany.value === 0 || temparray[i].therapy_price_fieldcompany_id === selectedCompany.value) {
                        temparray2.push(temparray[i])
                  }
            }
            console.log(requestinfos)
            console.log(temparray2)
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  therapy_slideold_percent,
                  therapy_slideold_min,
                  therapy_slideold_max,
                  therapySlideOlds,
                  therapy_price_baseinsurer_percent,
                  therapy_price_age_price,
                  therapy_price_urldesc,
                  therapy_price_desc,
                  therapy_price_disc,
                  selectedTherapyAge,
                  selectedTherapyInsurer,
                  optionCompany,
                  optionTherapyInsurer,
                  optionTherapyAge,
                  optionFranchise,
                  optionCovarage,
                  therapyInsurer,
                  therapyAge,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceTherapy,
                  therapy_price_id,
                  company_logo_url,
                  selectedCompany,
                  selectedFranchise,
                  selectedCovarage,
                  therapy_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه درمان: " + therapy_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">پوشش بیمه نامه </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"پوشش بیمه نامه"}
                                                                              value={selectedCovarage}
                                                                              onChange={this.handleCovarage}
                                                                              options={optionCovarage}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">فرانشیز </label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"فرانشیز"}
                                                                            value={selectedFranchise}
                                                                            onChange={this.handleFranchise}
                                                                            options={optionFranchise}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="تخفیف"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={therapy_price_disc}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="لینک"
                                                                        handleInputt={this.handleChangUrlDesc}
                                                                        value={therapy_price_urldesc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات"
                                                                        handleInputt={this.handleChangeDesc}
                                                                        value={therapy_price_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={therapy_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceTherapy ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewPriceTherapy}>
                                                                              {"ثبت قیمت بیمه درمان جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceTherapy}
                                                                              >
                                                                                    {"قیمت بیمه درمان جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceTherapy2}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه درمان"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceTherapy ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {therapyAge.map((therapyAge, index) => (
                                                                        <TherapyAge therapyAge={therapyAge} props={this.props} key={index} />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on">بازه سن بیمه شده </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"بازه سن بیمه شده"}
                                                                                          value={selectedTherapyAge}
                                                                                          onChange={this.handleTherapyAge}
                                                                                          options={optionTherapyAge}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت بیمه نامه "
                                                                                    handleInputt={this.handleChangeTherapyAge}
                                                                                    value={therapy_price_age_price}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceTherapyAge}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {therapyInsurer.map((therapyInsurer, index) => (
                                                                        <TherapyInsurer
                                                                              therapyInsurer={therapyInsurer}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on">بیمه گر پایه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"بیمه گر پایه"}
                                                                                          value={selectedTherapyInsurer}
                                                                                          onChange={this.handleTherapyInsurer}
                                                                                          options={optionTherapyInsurer}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder=" درصد اضافه نرخ "
                                                                                    handleInputt={this.handleChangeTherapyInsurer}
                                                                                    value={therapy_price_baseinsurer_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceTherapyInsurer}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {therapySlideOlds.map((therapySlideOld, index) => (
                                                                        <TherapySlideOld
                                                                              therapySlideOld={therapySlideOld}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceTherapy ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="از تعداد"
                                                                                    handleInputt={this.handleSlidePriceOldMin}
                                                                                    value={therapy_slideold_min}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="تا تعداد"
                                                                                    handleInputt={this.handleSlidePriceOldMax}
                                                                                    value={therapy_slideold_max}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="درصد تخفیف"
                                                                                    handleInputt={this.handleChangeSlideOldPercent}
                                                                                    value={therapy_slideold_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceTherapyOld}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"therapy_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "therapy_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "therapy_price_id"}
                                                                                          direction={orderBy === "therapy_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("therapy_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"therapy_price_coverage_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پوشش بیمه نامه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "therapy_price_coverage_id"}
                                                                                          direction={
                                                                                                orderBy === "therapy_price_coverage_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("therapy_price_coverage_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"therapy_price_franchise_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"فرانشیز"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "therapy_price_franchise_id"}
                                                                                          direction={
                                                                                                orderBy === "therapy_price_franchise_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("therapy_price_franchise_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"therapy_price_disc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "therapy_price_disc"}
                                                                                          direction={orderBy === "therapy_price_disc" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("therapy_price_disc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"therapy_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه درمان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "therapy_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "therapy_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("therapy_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["therapy_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"therapy_price_id"} align={"center"}>
                                                                                                      {row["therapy_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"therapy_price_coverage_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["therapy_coverage_name"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"therapy_price_franchise_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["therapy_franchise_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"therapy_price_disc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["therapy_price_disc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"therapy_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["therapy_price_deactive"] === "1" ||
                                                                                                      row["therapy_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه درمان را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePriceTherapy} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceTherapy)
